export default __webpack_public_path__ + "static/media/toys.07dc9227.svg";